export default __webpack_public_path__ + "static/media/8a50e165329c35034ee139d4aa8fa1e3.02a654db.png";